const hy = {
  inDevTxt: 'In Development',
  doneTxt: 'Done',
};

export default hy;
